import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from '@openx/design-system/components/Button/Button.tsx';
import { IconButton } from '@openx/design-system/components/Button/IconButton.tsx';
import { CaretLeftIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

type OpenXAgentPanelHeaderProps = {
  title: string;
  onBack: () => void;
  onExport?: (() => void) | undefined;
};

export const OpenXAgentPanelHeader = ({ title, onBack, onExport }: OpenXAgentPanelHeaderProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: 36 }}>
      <IconButton aria-label={t('Back')} data-test="openx-agent-panel-back" onClick={onBack}>
        <CaretLeftIcon />
      </IconButton>

      <Typography variant="h1" component="h2" noWrap sx={{ flex: 1 }}>
        {title}
      </Typography>

      <Button variant="contained" data-test="openx-agent-panel-export" onClick={onExport} sx={{ flexShrink: 0, ml: 1 }}>
        {t('Export')}
      </Button>
    </Box>
  );
};
